/**
 * @generated SignedSource<<c8df2b6fab04155a684e3008776d5c0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EstimatedValue_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item" | "pricingGuidanceTracking_item" | "useGetEstimatedValueRange_item" | "useShowPricingGuidance_item">;
  readonly " $fragmentType": "EstimatedValue_item";
};
export type EstimatedValue_item$key = {
  readonly " $data"?: EstimatedValue_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"EstimatedValue_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EstimatedValue_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetEstimatedValueRange_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "pricingGuidanceTracking_item",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "priceBookName",
              "variableName": "priceBookName"
            },
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            }
          ],
          "concreteType": "PricingGuidance",
          "kind": "LinkedField",
          "name": "pricingGuidance",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "minAmount",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "maxAmount",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "kind": "RootArgument",
          "name": "isTrade"
        },
        {
          "kind": "RootArgument",
          "name": "priceBookName"
        },
        {
          "kind": "RootArgument",
          "name": "userCountryCode"
        },
        {
          "kind": "RootArgument",
          "name": "userId"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "795866bf0f02c6b33d35748b1b254658";

export default node;
